/**
 * NUIT — Número Único de Identificação Tributária: 9 dígitos.
 *
 * Não validamos dígito de controlo: o algoritmo não é público e uma
 * validação errada bloquearia NUITs verdadeiros. [CONFIRMAR com a AT]
 */
export const NUIT_RE = /^\d{9}$/;
/**
 * NUIT genérico para consumidor final em VD/FR sem identificação.
 * [CONFIRMAR com a AT o valor esperado — docs/01-CONFORMIDADE-LEGAL.md §9.6]
 */
export const FINAL_CONSUMER_NUIT = '999999999';
export const FINAL_CONSUMER_NAME = 'Consumidor Final';
/** Remove espaços/pontos/hífenes que as pessoas metem ao escrever o NUIT. */
export function normalizeNuit(v) {
    if (!v)
        return null;
    const s = v.replace(/[\s.\-]/g, '');
    return s === '' ? null : s;
}
export function isValidNuit(v) {
    const s = normalizeNuit(v);
    return s !== null && NUIT_RE.test(s);
}
//# sourceMappingURL=nuit.js.map